import React from "react";

export const AppContext = React.createContext({
  showPG13: false,
});